import * as React from 'react';
import type { SVGProps } from 'react';
const SvgImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      d="M19.031 3H4.171A2.174 2.174 0 0 0 2 5.173V18.83C2 20.027 2.974 21 4.172 21h14.86c1.197 0 2.17-.973 2.17-2.17V5.173c0-1.2-.973-2.173-2.17-2.173Zm-4.614 3.231a2.098 2.098 0 1 1 0 4.196 2.098 2.098 0 0 1 0-4.196Zm3.933 12.761H5.152c-.58 0-.837-.419-.576-.936l3.6-7.13c.26-.517.758-.563 1.11-.103l3.62 4.73c.352.46.967.5 1.375.087l.885-.897c.407-.412 1.007-.36 1.339.114l2.293 3.275c.331.476.131.86-.448.86Z"
    />
  </svg>
);
export default SvgImage;
